import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=4edf6b74&scoped=true&"
import script from "./Solution.vue?vue&type=script&lang=js&"
export * from "./Solution.vue?vue&type=script&lang=js&"
import style0 from "./Solution.vue?vue&type=style&index=0&id=4edf6b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf6b74",
  null
  
)

export default component.exports